import { startOfDay, subDays, startOfWeek, startOfMonth, subMonths, endOfMonth, subWeeks } from 'date-fns'

export const API_URL = process.env.API_URL
export const EMAIL_DOMAIN = process.env.EMAIL_DOMAIN

export const JWT_TOKEN_KEY = 'JWT_TOKEN'

export const DATE_FORMAT = {
    SHORT_DATE_TIME: 'yyyy/MM/dd HH:mm',
    SHORT_DATE: 'yyyy/MM/dd',
    SHORT_DATE_ISO: 'yyyy-MM-dd',
    SHORT_DATE_ISO_PT: 'dd-MM-yyyy',
    UTC_DATE_TIME: 'yyyy/MM/dd HH:mm:ss.SSS',
}

export const FILTER_DATE = {
    NONE: {
        KEY: 'NONE',
        START_DATE: null,
        END_DATE: null,
        PERIOD_NAME: 'Selecione o período desejado',
    },
    TODAY: {
        KEY: 'TODAY',
        START_DATE: startOfDay(new Date()),
        END_DATE: new Date(),
        PERIOD_NAME: 'Hoje',
    },
    YESTERDAY: {
        KEY: 'YESTERDAY',
        START_DATE: subDays(new Date(), 1),
        END_DATE: new Date(),
        PERIOD_NAME: 'Ontem',
    },
    WEEK: {
        KEY: 'WEEK',
        START_DATE: startOfWeek(new Date()),
        END_DATE: new Date(),
        PERIOD_NAME: 'Essa semana',
    },
    LAST_WEEK: {
        KEY: 'LAST_WEEK',
        START_DATE: subWeeks(startOfWeek(new Date()), 1),
        END_DATE: subDays(startOfWeek(new Date()), 1),
        PERIOD_NAME: 'Semana passada',
    },
    MONTH: {
        KEY: 'MONTH',
        START_DATE: startOfMonth(new Date()),
        END_DATE: new Date(),
        PERIOD_NAME: 'Esse mês',
    },
    LAST_MONTH: {
        KEY: 'LAST_MONTH',
        START_DATE: startOfMonth(new Date(subMonths(new Date(), 1))),
        END_DATE: endOfMonth(new Date(subMonths(new Date(), 1))),
        PERIOD_NAME: 'Mês passado',
    },
    PERIOD: {
        KEY: 'PERIOD',
        START_DATE: null,
        END_DATE: null,
        PERIOD_NAME: 'Período personalizado',
    },
}
